(() => {
  'use strict';

  const maisonMessages = JSON.parse(document.querySelector('[data-maison-messages]')?.textContent || '{}');
  const maisonCartLabels = new Set(['Continue shopping button', 'Continue your shopping button',
    'Continuer vos achats button', 'Weiter einkaufen button', 'Verder winkelen button', 'Close cart', 'Decrease quantity button', 'Quantity input',
    'Increase quantity button', 'Remove item button', 'Checkout button', 'Trust badge']);
  const maisonGiftCard = document.body.hasAttribute('data-maison-gift-card');
  const maisonRoots = new Map();
  const maisonSelector = '.qsc2-drawer-wrapper, .yotpo-reviews-carousel-widget-container, .klaviyo-close-form' + (maisonGiftCard ? ', kaching-bundles-block' : '');

  const maisonAmountSources = new Set(['Waarden', 'Valeurs', 'Values', 'Werte']);
  function maisonMessage(key, values) {
    let value = maisonMessages[key] || '';
    for (const [name, replacement] of Object.entries(values)) value = value.split('{{ ' + name + ' }}').join(replacement);
    return value;
  }

  function maisonText(node, sources) {
    for (const child of node.childNodes) {
      if (child.nodeType === 3) {
        const translated = sources[child.textContent.trim()];
        if (translated && child.textContent.trim() !== translated) child.textContent = translated;
      } else if (child.nodeType === 1) maisonText(child, sources);
    }
  }

  function maisonApply(root) {
    if (root.matches('.qsc2-drawer-wrapper')) {
      for (const node of root.querySelectorAll('[aria-label], [alt]')) {
        for (const attribute of ['aria-label', 'alt']) {
          const source = node.getAttribute(attribute);
          const translated = maisonCartLabels.has(source) && maisonMessages[source];
          if (translated && translated !== source) node.setAttribute(attribute, translated);
        }
      }
    } else if (root.matches('.klaviyo-close-form')) {
      if (['Close teaser', 'Close dialog'].includes(root.getAttribute('aria-label')) && maisonMessages.app_close) {
        root.setAttribute('aria-label', maisonMessages.app_close);
      }
      maisonText(root, { 'Close teaser': maisonMessages.app_close, 'Close dialog': maisonMessages.app_close });
    } else if (root.matches('.yotpo-reviews-carousel-widget-container')) {
      for (const node of root.querySelectorAll('[aria-label], [title]')) {
        for (const attribute of ['aria-label', 'title']) {
          const source = node.getAttribute(attribute) || '';
          const rating = source.match(/^([0-5](?:[.,][0-9]+)?) out of 5 stars$/);
          const slide = source.match(/^slide ([0-9]+) out of ([0-9]+)$/);
          let translated = '';
          if (rating) {
            if (attribute === 'aria-label') node.dataset.maisonRatingSource = source;
            translated = maisonMessage('review_stars', { rating: new Intl.NumberFormat(document.documentElement.lang || 'en').format(Number(rating[1].replace(',', '.'))) });
          } else if (slide) translated = maisonMessage('review_slide', { index: slide[1], total: slide[2] });
          else if (source === 'Read more') translated = maisonMessages.read_more;
          else if (source === 'Read less') translated = maisonMessages.read_less;
          else if (source === 'Loved by 20,000+ customers') translated = maisonMessages['Customer reviews'];
          if (translated && translated !== source) node.setAttribute(attribute, translated);
        }
      }
      for (const node of root.querySelectorAll('button, [role=button], a')) {
        if (['Read more', 'Read less'].includes(node.textContent.trim())) {
          maisonText(node, { 'Read more': maisonMessages.read_more, 'Read less': maisonMessages.read_less });
        }
      }
    } else if (maisonGiftCard && root.matches('kaching-bundles-block')) {
      for (const node of root.querySelectorAll('.kaching-bundles__bar-variant-names > span')) {
        if (maisonAmountSources.has(node.textContent.trim()) && maisonMessages.gift_card_amount) {
          node.textContent = maisonMessages.gift_card_amount;
        }
      }
      for (const node of root.querySelectorAll('select[aria-label]')) {
        if (maisonAmountSources.has(node.getAttribute('aria-label')) && maisonMessages.gift_card_amount) node.setAttribute('aria-label', maisonMessages.gift_card_amount);
      }
    }
  }

  function maisonAttach(root) {
    if (maisonRoots.has(root)) return;
    maisonApply(root);
    const observer = new MutationObserver(() => maisonApply(root));
    observer.observe(root, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['aria-label', 'alt', 'title'], characterData: true });
    maisonRoots.set(root, observer);
  }

  function maisonDiscover(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(maisonSelector)) maisonAttach(node);
    node.querySelectorAll(maisonSelector).forEach(maisonAttach);
  }

  maisonDiscover(document.body);
  const maisonDiscovery = new MutationObserver((records) => {
    for (const record of records) record.addedNodes.forEach(maisonDiscover);
    for (const [root, observer] of maisonRoots) {
      if (!root.isConnected) { observer.disconnect(); maisonRoots.delete(root); }
    }
  });
  maisonDiscovery.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pagehide', (event) => {
    if (event.persisted) return;
    maisonDiscovery.disconnect();
    for (const observer of maisonRoots.values()) observer.disconnect();
    maisonRoots.clear();
  });
})();
